import React, { useState } from "react"
import { closeNavSchool } from "../../scripts/loginMenus.js"
import axios from "../../http/axios"
import { useTranslation } from "react-i18next"

import ArrowLeftIconDark from "../../svg/arrow-left-dark.inline.svg"

import EyeIcon from "../../svg/opened-eye-icon.inline.svg"
import EyeIconClosed from "../../svg/closed-eye-icon.inline.svg"

import XButtonIcon from "../../svg/x-button.inline.svg"
import { AUTH_TOKEN_KEY } from "../../constants/constants"
import { useCurrentUser } from "../../components/CurrentUserContext"

import SideNavForgotPasswordSection from "../../sections/login_signup_side_navs/SideNavForgotPasswordSection"

import SideNavForgotPasswordCheckMailSection from "../../sections/login_signup_side_navs/SideNavForgotPasswordCheckMailSection"
import { notification } from "antd"

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
)

const SchoolSideNavSection = () => {
  const { t } = useTranslation()

  const { fetchCurrentUser } = useCurrentUser()

  const [emailTriggered, setEmailTriggered] = useState(false)
  const [passwordTriggered, setPasswordTriggered] = useState(false)
  const [incorrectData, setIncorrectData] = useState(false)
  const [accessErr, setAccessErr] = useState(false)

  let emailLengthZero = emailTriggered ? "email-length-zero" : ""
  let passwordLengthZero = passwordTriggered ? "password-length-zero" : ""

  //Toggle eye
  const [passwordShown, setPasswordShown] = useState(false)
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true)
  }

  const toggled = passwordShown ? "toggled" : ""

  //Forgot password
  const [passwordForgot, setPasswordForgot] = useState(false)
  const togglePasswordForgot = () => {
    setPasswordForgot(passwordForgot ? false : true)
  }

  //Become member
  const [becomeMember, setBecomeMember] = useState(false)
  const toggleBecomeMember = () => {
    setBecomeMember(becomeMember ? false : true)
  }

  //Check email
  const [checkEmail, setCheckEmail] = useState(false)
  const toggleCheckEmail = () => {
    setCheckEmail(checkEmail ? false : true)
  }

  //Application thanks
  const [appThanks, setAppThanks] = useState(false)
  const toggleAppThanks = () => {
    setAppThanks(appThanks ? false : true)
  }

  let backToLogin = "block"

  let forgot =
    passwordForgot && !becomeMember && !checkEmail && !appThanks
      ? "block"
      : "none"
  let member =
    !passwordForgot && becomeMember && !checkEmail && !appThanks
      ? "block"
      : "none"
  let mail = checkEmail ? "block" : "none"
  let thanks = appThanks ? "block" : "none"

  backToLogin =
    forgot === "none" &&
    member === "none" &&
    mail === "none" &&
    thanks === "none" &&
    !passwordForgot &&
    !becomeMember &&
    !checkEmail &&
    !appThanks
      ? "block"
      : "none"

  function okThanks() {
    toggleCheckEmail()
    togglePasswordForgot()
  }

  function onAppThanks() {
    toggleAppThanks()
    toggleBecomeMember()
  }

  const setLoginResult = token => {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
    fetchCurrentUser()
    closeNavSchool()
  }

  const [formValues, setFormValues] = useState({ email: "", password: "" })

  function handleSubmit(e) {
    e.preventDefault()
    const config = {
      headers: {
        scope: "school",
      },
    }
    setAccessErr(false)
    axios
      .post(
        "/auth/login",
        {
          email: formValues.email,
          password: formValues.password,
        },
        config
      )
      .then(res => {
        setLoginResult(res.data)
      })
      .catch(error => {
        if (error.response.status === 403) {
          setAccessErr(true)
          return
        }

        if (error.response.data === "Invalid email or password") {
          setIncorrectData(true)
        }

        if (error.response.data.errors?.Email != undefined) {
          setEmailTriggered(true)
        }
        if (error.response.data.errors?.Password != undefined) {
          setPasswordTriggered(true)
        }
      })
  }

  const handleInputChanges = e => {
    e.persist()
    setEmailTriggered(false)
    setPasswordTriggered(false)
    setIncorrectData(false)

    setFormValues(currValues => ({
      ...currValues,
      [e.target.name]: e.target.value,
    }))
  }

  const [emailToPass, setEmailToPass] = useState()

  const processUserEmail = email => {
    setEmailToPass(email.config.data.replace(/{|}|"|:|email/g, ""))
  }

  return (
    <div id="side-nav-school" className="sidenav-user">
      <div
        className="side-nav-user-wrapper"
        id="school-wrapper"
        style={{ display: backToLogin }}
      >
        <div className="side-nav-user-top d-flex justify-content-between row px-3">
          <div className="ps-5 f-ac f-js f-1">
            <div className="sign-up-btn f-ac">
              <div
                className="x-button-wrapper f-ac f-jc curs-P"
                onClick={closeNavSchool}
              >
                <XButtonIcon className="x-button" />
              </div>
              <div className="sign-up-text">
                {t("school.header.schoolLogin")}
              </div>
            </div>
          </div>
          <div className="f-ac f-je f-1 right-side">
            <div className="side-nav-user-right-item item-having-acc">
              {t("main.header.addYourSchool")}
            </div>
            <div
              className="side-nav-user-right-item item-sign-up closebtn icon_button"
              id="backSchool"
              onClick={toggleBecomeMember}
            >
              {t("main.header.becomeAMember")}
            </div>
          </div>
        </div>

        <div className="container">
          <div className="side-nav-user-info">
            <form onSubmit={handleSubmit} noValidate>
              <div className="input-group special-group d-flex flex-column">
                <input
                  className={`form-field ${emailLengthZero}`}
                  type="email"
                  name="email"
                  required
                  placeholder={t("main.header.userNameOrMail")}
                  value={formValues.email}
                  onChange={handleInputChanges}
                />
                {/* <label>Username or email</label> */}
                {emailTriggered && (
                  <span className={`error email-validation ${emailLengthZero}`}>
                    {t("main.header.emailRequired")}
                  </span>
                )}
              </div>

              <div className="password-input-groups-wrapper">
                <div className="input-group special-group d-flex flex-column">
                  <input
                    id="passwordn"
                    className={`form-field ${passwordLengthZero}`}
                    type={passwordShown ? "text" : "password"}
                    name="password"
                    required
                    value={formValues.password}
                    onChange={handleInputChanges}
                    placeholder={t("main.header.password")}
                  />

                  {/* <label>{t('main.header.password')}</label> */}

                  {passwordTriggered && (
                    <span
                      className={`error password-validation ${passwordLengthZero}`}
                    >
                      {t("main.header.passwordRequired")}
                    </span>
                  )}

                  {incorrectData && (
                    <span className={`error`}>
                      {t("main.header.incorrectLoginData")}
                    </span>
                  )}

                  {accessErr && (
                    <span className={`error`}>{t("main.accessDenied")}</span>
                  )}
                </div>

                <EyeIcon
                  className={`password-eye ${toggled}`}
                  id="togglePassword2"
                  onClick={togglePasswordVisiblity}
                />
                <EyeIconClosed
                  className={`password-eye crossed-eye-icon ${toggled}`}
                  id="togglePassword2"
                  onClick={togglePasswordVisiblity}
                />
              </div>

              <button className="form-field login-button" type="submit">
                {t("main.header.logIn")}
              </button>

              <div
                className="forgot-password form-field"
                id="fpass-school"
                onClick={togglePasswordForgot}
              >
                {t("main.header.forgotPassword")}
              </div>
            </form>
          </div>
        </div>
      </div>
      {passwordForgot && !checkEmail && !appThanks && (
        <SideNavForgotPasswordSection
          backFunction={togglePasswordForgot}
          checkEmailFunction={toggleCheckEmail}
          passUserEmail={processUserEmail}
        />
      )}
      <SideNavBecomeMemberSection
        displayStyle2={member}
        backFunction2={toggleBecomeMember}
        thanksFunction={toggleAppThanks}
      />
      {checkEmail && (
        <SideNavForgotPasswordCheckMailSection
          backFunction3={okThanks}
          userEmailForPassReset={emailToPass}
        />
      )}
      <SideNavApplicationThanksSection
        displayStyle4={thanks}
        backFunction4={onAppThanks}
      />
    </div>
  )
}

export default SchoolSideNavSection

const SideNavBecomeMemberSection = props2 => {
  const [emailTriggered, setEmailTriggered] = useState(false)
  const [emailNotValid, setEmailNotValid] = useState(false)

  const [firstNameTriggered, setFirstNameTriggered] = useState(false)
  const [lastNameTriggered, setLastNameTriggered] = useState(false)
  const [positionTriggered, setPositionTriggered] = useState(false)
  const [schoolNameTriggered, setSchoolNameTriggered] = useState(false)

  let firstNameLengthZero = firstNameTriggered ? "firstName-length-zero" : ""
  let lastNameLengthZero = lastNameTriggered ? "lastName-length-zero" : ""
  let positionLengthZero = positionTriggered ? "position-length-zero" : ""
  let schoolNameLengthZero = schoolNameTriggered ? "schoolName-length-zero" : ""

  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const handleReset = () => {
    Array.from(document.querySelectorAll("input")).forEach(
      input => (input.value = "")
    )
    setFormValues3({
      formValues: [{}],
    })
  }

  const [formValues, setFormValues3] = useState({
    firstName: "",
    lastName: "",
    position: "",
    schoolName: "",
    email: "",
    referral: "",
    languageCode: "",
  })

  function handleSubmit(e) {
    e.preventDefault()
    axios
      .post("/schools/new-member", {
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        position: formValues.position,
        schoolName: formValues.schoolName,
        email: formValues.email,
        referral: formValues.referral,
        languageCode: currentLang,
      })
      .then(res => {
        handleReset()
        props2.thanksFunction()
      })
      .catch(error => {
        if (error.response.data.errors?.Email != undefined) {
          setEmailTriggered(true)
        }
        if (error.response.data.errors?.FirstName != undefined) {
          setFirstNameTriggered(true)
        }
        if (error.response.data.errors?.LastName != undefined) {
          setLastNameTriggered(true)
        }
        if (error.response.data.errors?.Position != undefined) {
          setPositionTriggered(true)
        }
        if (error.response.data.errors?.SchoolName != undefined) {
          setSchoolNameTriggered(true)
        }
        notification.error({
          message: error.response.data.message,
          placement: "topRight",
        })
      })
  }

  const [formValidation, setFormValidation] = useState({
    email: null,
    password: null,
    errors: {
      email: "",
      password: "",
      firstname: "",
      lastname: "",
      phone: "",
    },
  })

  const handleInputChanges = e => {
    e.persist()
    const { name, value } = e.target
    let validationErrors = formValidation.errors
    setEmailTriggered(false)
    setFirstNameTriggered(false)
    setLastNameTriggered(false)
    setPositionTriggered(false)
    setSchoolNameTriggered(false)

    switch (name) {
      case "email":
        validationErrors.email = validEmailRegex.test(value)
          ? ""
          : "Invalid email"
        break
      case "password":
        break
      case "name":
        break
      default:
        break
    }

    setFormValidation({ errors, [name]: value })

    if (errors.email === "Invalid email") {
      setEmailNotValid(true)
    } else {
      setEmailNotValid(false)
    }

    setFormValues3(currValues => ({
      ...currValues,
      [e.target.name]: e.target.value,
    }))
  }

  let emailLengthZero = emailTriggered ? "email-length-zero" : ""
  let emailIsNotValid = emailNotValid ? "email-not-valid" : ""

  const { errors } = formValidation
  return (
    <div
      id="side-nav-school"
      className="sidenav-user"
      style={{ display: props2.displayStyle2 }}
    >
      <div className="side-nav-user-wrapper" id="school-wrapper">
        <div className="ps-5 side-nav-user-top">
          <div className="f-ac f-js f-1">
            <div className="sign-up-btn f-ac">
              <div
                id="backSchool"
                className="x-button-wrapper f-ac f-jc curs-P"
                onClick={props2.backFunction2}
              >
                <ArrowLeftIconDark className="arrow_left_dark" />
              </div>
              <div className="sign-up-text">
                {t("main.header.newSchoolMember")}
              </div>
            </div>
          </div>
        </div>
        <div className="side-nav-user-info new-school-member">
          <form onSubmit={handleSubmit} noValidate>
            <div className="login-with-wrapper">
              <div className="title-forgot-password">
                {t("main.header.newSchoolMember")}
              </div>
            </div>
            <div className="school-member-fields-wrapper">
              <div className="input-group d-flex flex-column">
                <input
                  type="text"
                  name="firstName"
                  className={`form-field ${firstNameLengthZero}`}
                  required
                  value={formValues.firstName}
                  onChange={handleInputChanges}
                  placeholder={t("main.header.firstName")}
                />

                {firstNameTriggered && (
                  <span
                    className={`error firstName-validation ${firstNameLengthZero}`}
                  >
                    {t("main.header.firstNameRequired")}
                  </span>
                )}
              </div>
              <div className="input-group d-flex flex-column">
                <input
                  type="text"
                  name="lastName"
                  className={`form-field ${lastNameLengthZero}`}
                  required
                  value={formValues.lastName}
                  onChange={handleInputChanges}
                  placeholder={t("main.header.lastName")}
                />

                {lastNameTriggered && (
                  <span
                    className={`error lastName-validation ${lastNameLengthZero}`}
                  >
                    {t("main.header.lastNameRequired")}
                  </span>
                )}
              </div>
              <div className="input-group d-flex flex-column">
                <input
                  type="text"
                  name="position"
                  className={`form-field ${positionLengthZero}`}
                  required
                  value={formValues.position}
                  onChange={handleInputChanges}
                  placeholder={t("main.header.position")}
                />

                {positionTriggered && (
                  <span
                    className={`error position-validation ${positionLengthZero}`}
                  >
                    {t("main.header.positionRequired")}
                  </span>
                )}
              </div>
              <div className="input-group d-flex flex-column">
                <input
                  type="text"
                  name="schoolName"
                  className={`form-field ${schoolNameLengthZero}`}
                  required
                  value={formValues.schoolName}
                  onChange={handleInputChanges}
                  placeholder={t("main.header.schoolName")}
                />

                {schoolNameTriggered && (
                  <span
                    className={`error schoolName-validation ${schoolNameLengthZero}`}
                  >
                    {t("main.header.schoolNameRequired")}
                  </span>
                )}
              </div>
              <div className="input-group d-flex flex-column">
                <input
                  type="email"
                  name="email"
                  className={`form-field ${emailIsNotValid} ${emailLengthZero}`}
                  required
                  placeholder={t("main.header.email")}
                  value={formValues.email}
                  onChange={handleInputChanges}
                />
                {/* <label>{t('main.header.email')}</label> */}

                {errors.email.length !== 0 && (
                  <span className="error">{t("main.header.ivalidEmail")}</span>
                )}
                {emailTriggered && (
                  <span className={`error email-validation ${emailLengthZero}`}>
                    {t("main.header.emailRequired")}
                  </span>
                )}
              </div>
              <div className="input-group d-flex flex-column">
                <input
                  placeholder={t("main.header.referralText")}
                  type="text"
                  name="referral"
                  className="form-field"
                  required
                  value={formValues.referral}
                  onChange={handleInputChanges}
                />
              </div>
              {/* <input className="form-field" type="text" placeholder="Last name name" name="uname" required=""/> */}
              <button
                className="form-field login-button"
                type="submit"
                id="createSchool"
              >
                {t("main.header.send")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

const SideNavApplicationThanksSection = props4 => {
  return (
    <div
      className="side-nav-user-wrapper"
      id="school-wrapper"
      style={{ display: props4.displayStyle4 }}
    >
      <div className="new-school-application-image"></div>
      <div className="side-nav-user-info f-js new-school-application-info">
        <div className="school-application-text">
          <div className="reset-pass-title">Thanks for your application</div>
          <div className="reset-pass-main-text">
            Our manager will process your application and contact you as soon as
            posible.
          </div>
          <div
            id="backSchool"
            className="form-field login-button thanks-btn"
            onClick={props4.backFunction4}
          >
            Ok, thanks
          </div>
        </div>
      </div>
    </div>
  )
}
